import { useMemo } from 'react';
import { useFm } from '@web3/base-hooks';
import { appPath, showShareModal, toFormat, isBrowser } from '@web3/base-utils';
import { SYMBOL_ICON_MORE_CHAINS } from '@/constants';
import { DEFAULT_VAL, TOTAL_REWARD_AMOUNT } from '@/utils/constant';
import { ChainInfo } from '@/types/wallet';
import { formatProjectRank } from '@/utils';

interface IProps {
  rewardAmount?: string;
  name: string;
  icon: string;
  chainList: ChainInfo[];
  track: string;
  supporters: number | string;
  points: number | string;
  projectRank: number | string;
  time: string;
}

/**  wsot项目详情页 分享 */
export const useProjectsShare = ({
  rewardAmount = TOTAL_REWARD_AMOUNT,
  name = DEFAULT_VAL,
  icon,
  chainList,
  track = DEFAULT_VAL,
  points = DEFAULT_VAL,
  supporters = DEFAULT_VAL,
  projectRank = DEFAULT_VAL,
  time,
}: IProps) => {
  const fm = useFm();

  const shareUrl = useMemo(() => {
    return isBrowser
      ? `${(window as any).location.href}&utm_content=share`
      : '';
  }, []);

  const showShare = () => {
    showShareModal({
      posterStyle: ['vertical'],
      link: shareUrl,
      content: `${fm('backProjectAtBybitSuperstar', { projectName: name, amount: rewardAmount })} ${shareUrl}`,
      channels: ['facebook', 'twitter', 'whatsapp', 'telegram', 'linkedin'],
      templateData: {
        showLogo: true,
        backgroundImage: {
          vertical: `${appPath}/png/profile/share-projects-bg.png`,
        },
        content: {
          desc: `<div class="share-content-wrap" style="margin-top: -20px;">
                <div>
                  <div class='relative inline-flex justify-center items-center'>
                    <img
                      style="display:inline-block"
                      class="w-14 h-14 rounded-full object-cover share-project-icon"
                      crossOrigin='anonymous'
                      src=${icon}
                      alt=""
                    ></img>
                    ${
                      chainList?.length
                        ? chainList?.length > 1
                          ? `<img
                            style="display:inline-block"
                            class="absolute bottom-0 right-0 w-5 h-5 rounded-full object-cover share-chain-icon"
                            src=${SYMBOL_ICON_MORE_CHAINS}
                            alt=""
                          />`
                          : `<img
                            style="display:inline-block"
                            class="absolute bottom-0 right-0 w-5 h-5 rounded-full object-cover share-chain-icon"
                            src=${chainList?.[0]?.chainIcon}
                            crossOrigin='anonymous'
                            alt=""
                          />`
                        : ''
                    }
                  </div>
                </div>

                  <p class="mt-[14px] flex justify-center items-center" style="gap:6px;">
                    <span class="share-leaf-lf"></span>  
                    <span class="sky-blue-color text-xl font-extrabold">${fm('ranking')} ${formatProjectRank(projectRank)}</span>
                    <span class="share-leaf-rt"></span>  
                  </p>

                  <h1 class="share-projects-title text-xs font-semibold">
                  ${fm('joinBybitAIDolSuperstarProject', { projectName: name })}
                  </h1> 

                  <div class="share-green-box share-supporter-box-height flex justify-between items-center mt-4" style="padding: 14px 0;"> 
                    <div style="width: 130px"> 
                      <h5  class="text-xs font-semibold gray-color">${fm('wsotPt')}</h5>  
                      <p class="mt-1 text-base font-extrabold">${points !== 0 ? toFormat(points, 0) : '--'}</p>  
                    </div>

                    <span class="share-divide-line"></span>  

                     <div style="width: 130px"> 
                      <h5 class="text-xs font-semibold gray-color">${fm('supporters')}</h5>  
                      <p class="mt-1 text-base font-extrabold">${toFormat(supporters, 0)}</p>  
                    </div>

                  </div>
                    <div class="inline-flex justify-center items-center mt-4 text-xs" style="width: 280px;">
                      <span class="inline-block w-3 h-3 mr-1 share-clock-icon"></span>
                      ${fm('updatedOnTimeUtc', { time })}
                    </div>
                </div>`,
        },
        bottom: {
          showCode: false,
          desc: fm('scanQrVoteForProject', { projectName: name }),
        },
      },
    });
  };

  return {
    showShare,
  };
};
